import { useEffect, useState } from "react";
import { ChevronLeft, X } from "react-feather";
import { Col, Form, Input, Row } from "reactstrap";
import { Href } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { profileSideBarToggle, setMobileMenu, setProfileSidebarWidth } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";
import Contact from "./Contact";
import { dynamicImage, Image } from "../../../../../Utils";

const ChatHeader = () => {
  const [search, setSearch] = useState(false);
  const dispatch = useAppDispatch();
  const { selectedUser } = useAppSelector((state) => state.chat);

  useEffect(() => {
    const updateSize = () => dispatch(setProfileSidebarWidth(window.innerWidth));
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [dispatch]);


  return (
    <div className="contact-details">
      <Row>
        <Form className={`form-inline search-form ${search ? "open" : ""}`}>
          <div className="form-group">
            <Input className="form-control-plaintext" type="search" placeholder="Search.." />
            <div className="icon-close close-search" onClick={() => setSearch(!search)}><X /></div>
          </div>
        </Form>
        <Col xs="5">
          <div className="d-flex left gap-2">
            <div className="media-right">
              <ul>
                <li>
                  <a className="icon-btn bg-light-primary button-effect mobile-sidebar" href={Href} onClick={() => dispatch(setMobileMenu())}><ChevronLeft />                  </a>
                </li>
              </ul>
            </div>
            <div className="media-left" onClick={() => dispatch(profileSideBarToggle())}>
              <div className={`profile online menu-trigger ${selectedUser?.onlineStatus}`}>{selectedUser?.thumb ? <Image className="bg-img img-fluid" src={dynamicImage(selectedUser.thumb)} alt="Avatar" /> : <span>{selectedUser?.name.split(" ").map((name) => name[0])}</span>}</div>
            </div>
            <div className="flex-grow-1">
              <h3 className="mb-2">{selectedUser?.name ? selectedUser?.name : "Lea"}</h3>
              <h5>Online</h5>
            </div>
          </div>
        </Col>
        <Contact search={search} setSearch={setSearch} />
      </Row>
    </div>
  );
};

export default ChatHeader;
